import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommendations from './components/HotRecommendations';
import LatestUpdates from './components/LatestUpdates';
import HotRanking from './components/HotRanking';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <HotRecommendations />
        <LatestUpdates />
        <HotRanking />

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-100 mb-3">
              为什么选择牛牛影视？
            </h2>
            <p className="text-sm text-foreground-500 mb-8 max-w-2xl mx-auto">
              我们致力于为用户提供优质的在线观影体验
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { icon: 'ri-movie-2-line', title: '海量资源', desc: '万部影视资源' },
                { icon: 'ri-4k-line', title: '高清画质', desc: '流畅不缓冲' },
                { icon: 'ri-refresh-line', title: '每日更新', desc: '最新剧集同步' },
                { icon: 'ri-device-line', title: '多端适配', desc: '随时随地观看' },
              ].map((item) => (
                <div key={item.title} className="flex flex-col items-center gap-2">
                  <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center">
                    <i className={`${item.icon} text-xl text-primary-400`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-100">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '牛牛影视 - 首页',
            description: '牛牛影视聚合海量电影、电视剧、综艺节目，每日更新最新影视资源，一站式满足追剧观影需求。',
            url: 'https://oil-zero.cn',
            isPartOf: {
              '@type': 'WebSite',
              name: '牛牛影视',
              url: 'https://oil-zero.cn',
            },
          }),
        }}
      />
    </>
  );
}